import { HttpTransportType, HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import ModuleNotification from "./ModuleNotification";
import * as uuid from 'uuid';

type Callback = (message: any) => any;

type SubscriptionItem = {
    id: string;
    module: string;
    event: string;
    callback: Callback;
}

interface Subscription {
    unsubscribe(): void
}

class RealTimeConnectionManager {
    private readonly connection: HubConnection;
    private url: string = 
        process.env.REACT_APP_REAL_TIME_URL ||
        '/real-time/notifications';

    private readonly subscribers: SubscriptionItem[] = []

    constructor() {

        //const protocol = new JsonHubProtocol();

        // let transport to fall back to to LongPolling if it needs to
        const transport = HttpTransportType.WebSockets | HttpTransportType.LongPolling;

        const options = {
            transport,
            logMessageContent: true
        };

    
        this.connection = 
            new HubConnectionBuilder()
            .withUrl(this.url, options)
            .withAutomaticReconnect([0, 1000, 2000, 3000, 4000, 5000, 7500, 10000, 15000])
            .configureLogging(2)
            .build();

        this.connection
            .start()
            .then(() => {
                
                this.connection.on("module-notification", (message) => {
                    this.handleModuleNotification(message);
                });

                this.connection.on("alert-created", message => {
                    console.error(message);
                })

                this.connection.on('alert-dismissed', message => {
                    console.info(message);
                });

                this.connection.onreconnecting( (error) => {
                    console.log('Reconnecting', error);
                });

            })
            .catch((error) => console.log(error));

    }

    public subscribe(module: string, event: string, callback: Callback): Subscription {
        const id = uuid.v4();
        const subscriptionItem: SubscriptionItem = {
            id,
            module,
            event,
            callback
        };

        this.subscribers.push(subscriptionItem);

        return {
            unsubscribe: () => {
                const index = this.subscribers.findIndex(item => item.id === id);
                console.info('Unsubscribing')
                if(index !== -1) {
                    this.subscribers.splice(index, 1);
                }
            }
        }
    }

    private handleModuleNotification(message: ModuleNotification): void {
        this.subscribers
            .filter(s => s.module === message.moduleCode || s.module === '*')
            .forEach(s => {
                if(s.event === message.eventCode || s.event === '*') {
                    s.callback(message);
                }
            });
    }
}

const RealTimeService = new RealTimeConnectionManager();
export default RealTimeService;